module.exports = __webpack_public_path__ + "img/shield.a7c0aa29.png";